
<template lang="pug">
  .accordion-group
    slot
</template>

<script>
  export default {
    name: 'AccordionGroup',
    data () {
      return {
        accordions: []
      }
    },
    methods: {
      addAccordion (accordion) {
        this.accordions.push(accordion)
      },
      removeAccordion (accordion) {
        let index = this.accordions.findIndex(a => a._uid === accordion._uid)
        this.accordions.splice(index, 1)
      },
      activate ({ _uid }) {
        this.accordions.forEach((accordion) => {
          accordion.active = Boolean(_uid === accordion._uid)
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .accordion-group {
    
    // Styles to appear specifically on content pages
    #shopify-section-page .page-content & {
      margin-bottom: 2*$grid-gutter;
    }
  }
</style>